import React from 'react'
import { styled } from '@mui/material/styles'
import CircularProgress from '@mui/material/CircularProgress'
import { keyframes } from '@mui/material/styles'
const rotate = keyframes`
  0% {
      stroke-dasharray: 1px,200px;
      stroke-dashoffset: 0;
  }

  50% {
      stroke-dasharray: 100px,200px;
      stroke-dashoffset: -15px;
  }

  100% {
      stroke-dasharray: 100px,200px;
      stroke-dashoffset: -125px;
  }
`

const PREFIX = 'SpinningCircle'

const classes = {
  root: `${PREFIX}-root`
}

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    justifyContent: 'center',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    },
    circle: {
      strokeDasharray: '80px,200px',
      stroke: 'currentColor',
      animation: `${rotate} 1.4s ease-in-out infinite`
    }
  }
}))

const SpinningCircle = () => {
  return (
    <Root className={classes.root}>
      <CircularProgress color="primary" />
    </Root>
  )
}

export default SpinningCircle
